'use client';

import { motion } from 'framer-motion';

export function CoverSection() {
  return (
    <section className="relative w-full bg-white px-4 py-20 dark:bg-slate-950 md:py-32">
      <div className="mx-auto max-w-7xl">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="relative z-20 mx-auto max-w-5xl bg-gradient-to-b from-neutral-800 via-neutral-700 to-neutral-700 bg-clip-text py-6 text-center text-4xl font-semibold text-transparent dark:from-neutral-800 dark:via-white dark:to-white md:text-5xl lg:text-6xl"
        >
          Build amazing websites{' '}
          <motion.span
            initial={{ opacity: 0, filter: 'blur(10px)' }}
            whileInView={{ opacity: 1, filter: 'blur(0px)' }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="relative inline-block rounded-lg border-2 border-blue-500 px-4 py-2 text-blue-600 dark:border-blue-400 dark:text-blue-400"
          >
            at warp speed
          </motion.span>
        </motion.h1>
      </div>
    </section>
  );
}
